import type { Id } from '../aliases'
import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'

export type LookupSiteFileHash = {
  fileName: string
  fileHash: Id
}

export const LookupSiteFileHashSchema: CborSchema<LookupSiteFileHash> =
  defineCborSchema<LookupSiteFileHash>({
    fileName: CborField({ key: 0 }),
    fileHash: CborField({ key: 1 }),
  })
